// extracted by mini-css-extract-plugin
module.exports = {"openingQuote":"quote_openingQuote__ozGPt","closingQuote":"quote_closingQuote__kymvq"};